import * as React from 'react';
import { DirectionalHint } from '@fluentui/react/lib/Callout';
import { Lightable, LightningId, lighted } from 'owa-lightning-v2';
import { observer } from 'mobx-react-lite';
import { TeachingBubble } from '@fluentui/react/lib/TeachingBubble';
import { IImageProps } from '@fluentui/react/lib/Image';
import loc from 'owa-localize';
import {
    openAndEditInCloudFRECalloutMessageTitle,
    openAndEditInCloudFRECalloutMessageSubtitle,
} from './OpenAndEditInCloudFRECallout.locstring.json';

const styles = require('./OpenAndEditInCloudFRECallout.scss');
const imageProps: IImageProps = {
    src: require('./OpenAndEditInCloudFRECallout.svg'),
};

const OpenAndEditInCloudFRECallout = observer(function OpenAndEditInCloudFRECallout({
    target,
    lightningId,
}: {
    target: HTMLElement | React.RefObject<Element>;
    lightningId: LightningId;
}) {
    const onClose = React.useCallback(() => {
        lighted(lightningId);
    }, [lightningId]);

    return (
        <Lightable lid={lightningId} when={triggerLightup}>
            <TeachingBubble
                calloutProps={{
                    directionalHint: DirectionalHint.bottomAutoEdge,
                    className: styles.teachingBubble,
                }}
                illustrationImage={imageProps}
                target={target}
                hasCloseButton={true}
                onDismiss={onClose}
                headline={loc(openAndEditInCloudFRECalloutMessageTitle)}
                isWide={false}>
                {loc(openAndEditInCloudFRECalloutMessageSubtitle)}
            </TeachingBubble>
        </Lightable>
    );
});

function triggerLightup(lightup: () => void): void {
    setTimeout(() => lightup(), 500);
}

export default OpenAndEditInCloudFRECallout;
